<template>
    <transition name="modal" >
        <div class="modal-mask rounded-lg shadow-lg align-top verflow-y-auto">
          <div class="modal-wrapper rounded-lg shadow-lg overflow-auto ">
            <div class="modal-container overflow-y-auto ">
              <div class="modal-header relative  py-2">
                <slot name="header" >
                    <button  @click="$emit('close')">
                    <!-- <button @click="showModals" > -->
                        <div class="bg-warmGray-200 m-2">
                            <span class="mb-4 px-2 h-8 w-8 border-2
                            border-warmGray-600
                            bg-warmGray-300
                            text-namasteBlue rounded-md
                            font-semibold absolute top-0 right-0">
                                x
                                </span>
                                <!-- here  -->

                                <!-- till here  -->

                        </div>
                        </button>
                </slot>
              </div>
            <!-- here comes the modal body  -->
              <div class="modal-body border border-warmGray-200 min-h-screen">
                <slot name="body">
                    <cart-icon></cart-icon>
                    <!-- <order-summary></order-summary> -->
                    <basket-items></basket-items>
                    <order-summary></order-summary>
                    <order-buttoon v-if="showOrderButton"> </order-buttoon>
                     <!-- <basket
                    class="mt-4 min-h-screen md:max-w-d"
                    :cart="cart"
                    :basketItems="cartproducts">
                    </basket> -->
                </slot>
              </div>
             <!-- modal footer  -->
              <div class="modal-footer overflow-auto ">
                <slot name="footer">
                    <!-- test -->
                  <!-- default footer
                  <button class="modal-default-button" @click="$emit('close')">
                    OK
                  </button> -->
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
</template>
<script>

import CartIcon from '@/components/CartIcon.vue'
import BasketItems from '@/components/BasketItems.vue'
import OrderSummary from '@/components/OrderSummary.vue'
import { mapGetters } from 'vuex'
import OrderButtoon from './OrderButton.vue'

export default {
  props: {
    showOrderButton: Boolean
  },
  data () {
    return {
      cart: 0
    }
  },
  computed: {
    ...mapGetters({
      cartproducts: 'getCartProducts',
      totalCartItems: 'getTotalCartItems'
    })
  },
  components: {
    CartIcon,
    BasketItems,
    OrderSummary,
    OrderButtoon

  }
}
</script>
<style scoped>
.modal-mask {
  position: fixed;
  /* vertical-align: top; */
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(19, 18, 18, 0.5);
  display: table;
  transition: opacity 0.4s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: top;
  /* margin: 120px; */

}

.modal-container {
  /* width: 300px; */
  margin: 0px auto;
  padding: 20px 30px;
  background-color: rgb(243, 240, 240);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(14, 13, 13, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 2;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
